import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Es para mí si recién empiezo como profesor?',
    answer: 'Sí, el sistema está diseñado tanto para profesores nuevos como experimentados.'
  }, {
    question: '¿Cuánto tiempo necesito para ver resultados?',
    answer: 'Muchos profesores ven cambios en las primeras 2-3 semanas.'
  }, {
    question: '¿Qué formato tiene el producto?',
    answer: 'Es 100% digital. Recibirás acceso inmediato después de la compra.'
  }, {
    question: '¿Hay garantía?',
    answer: 'Sí, tienes 45 días de garantía. Si no te sirve, te devolvemos el dinero sin preguntas.'
  }, {
    question: '¿Puedo pagar con tarjeta?',
    answer: 'Sí, aceptamos todas las tarjetas de crédito y débito principales.'
  }];
  return <motion.section initial={{
    opacity: 0
  }} whileInView={{
    opacity: 1
  }} viewport={{
    once: true
  }} className="py-16 px-4" data-id="element-30">
      <div className="max-w-3xl mx-auto" data-id="element-31">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-32">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-33">
          {faqs.map((faq, index) => <div key={index} className="bg-card border border-gray-700 rounded-lg overflow-hidden" data-id="element-34">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-5 text-left hover:bg-card/80 transition-colors" data-id="element-35">
                <span className="font-semibold text-lg pr-4" data-id="element-36">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-primary flex-shrink-0 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-37" />
              </button>

              <AnimatePresence data-id="element-38">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-39">
                    <div className="p-5 pt-0 text-gray-300" data-id="element-40">{faq.answer}</div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </motion.section>;
}